// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_MAIN = '/main';
const ROOTS_MAGIC = '/ml';

// ----------------------------------------------------------------------

export const PATH_MAGIC = {
    root: ROOTS_MAGIC,
    guestJoinSession: path(ROOTS_MAGIC, '/join-session'),
    mobileGroupSession: path(ROOTS_MAGIC, '/group-session'),
    phoneCall: path(ROOTS_MAGIC, '/phone-call'),
};

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    adminLogin: path(ROOTS_AUTH, '/admin-login'),
    register: path(ROOTS_AUTH, '/register'),
    providerRegister: path(ROOTS_AUTH, '/provider-register'),
    verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_STATIC = {
    comingSoon: '/coming-soon',
    maintenance: '/maintenance',
    pricing: '/pricing',
    payment: '/payment',
    about: '/about-us',
    contact: '/contact-us',
    faqs: '/faqs',
    page403: '/403',
    page404: '/404',
    page500: '/500',
    components: '/components',
};

export const PATH_MAIN = {
    root: ROOTS_MAIN,
    permissionDenied: path(ROOTS_MAIN, '/permission-denied'),
    general: {
        dashboard: path(ROOTS_MAIN, '/dashboard'),
        liveSession: path(ROOTS_MAIN, '/live-session'),
        groupSession: path(ROOTS_MAIN, '/group-session'),
        appointments: path(ROOTS_MAIN, '/appointments'),
        appointmentDetails: path(ROOTS_MAIN, '/appointments/appointment'),
        rescheduleAppointment: path(ROOTS_MAIN, '/appointments/reschedule'),
        claims: path(ROOTS_MAIN, '/claims'),
        clients: path(ROOTS_MAIN, '/clients'),
        newClient: path(ROOTS_MAIN, '/clients/new'),
        providers: path(ROOTS_MAIN, '/providers'),
        newProvider: path(ROOTS_MAIN, '/providers/new'),
        providerDetails: path(ROOTS_MAIN, '/providers/provider'),
        bookProvider: path(ROOTS_MAIN, '/providers/book'),
        availability: path(ROOTS_MAIN, '/availability'),
        assessments: path(ROOTS_MAIN, '/assessments'),
        newAssessment: path(ROOTS_MAIN, '/assessments/new'),
        journals: path(ROOTS_MAIN, '/journals'),
        newJournal: path(ROOTS_MAIN, '/journals/new'),
        assignments: path(ROOTS_MAIN, '/assignments'),
        completedAssignments: path(ROOTS_MAIN, '/assignments/completed'),
        assignedAssignments: path(ROOTS_MAIN, '/assignments/assigned'),
        assignmentDetail: path(ROOTS_MAIN, '/assignments/detail'),
        assignmentLibrary: path(ROOTS_MAIN, '/assignment-library'),
        plans: path(ROOTS_MAIN, '/plans'),
        book: path(ROOTS_MAIN, '/book'),
        carebot: path(ROOTS_MAIN, '/carebot'),
        assistant: path(ROOTS_MAIN, '/assistant'),
        user: path(ROOTS_MAIN, '/user'),
        groups: path(ROOTS_MAIN, '/groups'),
        group: path(ROOTS_MAIN, '/groups/group'),
        newGroup: path(ROOTS_MAIN, '/groups/new'),
        messages: path(ROOTS_MAIN, '/messages'),
        escalations: path(ROOTS_MAIN, '/escalations'),
        members: path(ROOTS_MAIN, '/members'),
        careCircle: path(ROOTS_MAIN, '/care-circle'),
        careCircleFAQ: path(ROOTS_MAIN, '/care-circle-faq'),
        notifications: path(ROOTS_MAIN, '/notifications'),
    },
    onboarding: path(ROOTS_MAIN, '/onboarding'),
    community: path(ROOTS_MAIN, '/community'),
    provider: {
        knowledgeBase: path(ROOTS_MAIN, '/provider-knowledge-base'),
    },
    learn: path(ROOTS_MAIN, '/learn'),
    billingAndSubscription: path(ROOTS_MAIN, '/billing-and-subscription'),
    account: path(ROOTS_MAIN, '/account'),
    administrative: {
        organization: path(ROOTS_MAIN, '/administrative/organization'),
        organizations: path(ROOTS_MAIN, '/administrative/organizations'),
        payouts: path(ROOTS_MAIN, '/administrative/payouts'),
        users: path(ROOTS_MAIN, '/administrative/users'),
        audit: path(ROOTS_MAIN, '/administrative/audit'),
        settings: path(ROOTS_MAIN, '/administrative/settings'),
        faxManagement: path(ROOTS_MAIN, '/administrative/fax-management'),
    },
    payer: {
        settings: path(ROOTS_MAIN, '/payer/settings'),
    },
    organization: {
        members: path(ROOTS_MAIN, '/organization/members'),
        settings: path(ROOTS_MAIN, '/organization/settings'),
    },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
